import { lazy } from 'solid-js'
import { messages } from '../../pages/action-items-page/action-items-page-routing.messages.en.js'

// Reachable in normal flow only from the <1184px viewport via the
// minimized checklist's "See Action Items" button.
export default {
    component: lazy(() => import('../../pages/action-items-page/action-items-page.jsx')),
    path: '/property/:property_id/action-items',
    requiredMode: 'host',
    showFooter: false,
    showHeaderMenu: false,
    showHostView: true,
    showSidebar: true,
    titleMessage: messages.title,
}
